const JieSeriesDashboard = () => import('../index.vue');

export default [
  {
    path: '/jieSeriesDashboard',
    name: 'JieSeriesDashboard',
    component: JieSeriesDashboard,
    meta: {
      title: '捷系列运营态势',
      keepAlive: true,
      hideMenu: true,
      hideBreadcrumb: true,
    },
  },
];
